// ESM-Huelle um lib/scripts/pos/CLS_CUserRights.js (Phase 4, Welle 4b).
// Prototype-Stil bleibt vorerst.
function CUserRights() {
	this.pin = new Array();
}

CUserRights.prototype.setUserPropsPIN = function (UID, pin) {
	this.pin[UID] = pin;
}

CUserRights.prototype.getUserProps = function (UID) {
	/*privMan.enablePrivilege (privList);*/
	var dfd = jQuery.Deferred();
	var sql = "SELECT Type, Right FROM UR WHERE U_ID = " + UID;
	var me = this;
	
	$.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
		sql = "SELECT Login, Name, MaxRebate, MaxGlobalRebate FROM U WHERE U_ID = " + UID;
		$.when(POS.SQLiteCon.execute(sql)).then(function (rows2) {
			var userProps = new Array();

			userProps["Login"] = rows2[0].Login;
			userProps["Name"] = rows2[0].Name;
			userProps["MaxRebate"] = rows2[0].MaxRebate;
			userProps["MaxGlobalRebate"] = rows2[0].MaxGlobalRebate;
			userProps["PIN"] = me.pin[UID];
			for (var i = 0; i < rows.length; i++) {
				userProps[rows[i].Type] = rows[i].Right;
				//r.moveNext();
			}

			// r.free();
			//r2.free();
			dfd.resolve(userProps);
			//return userProps;
		});
	});
	return dfd.promise();
}

CUserRights.prototype.makeRights = function (main) {
	//LeftPad:

	if (typeof main.userProps["BOF"] != "undefined" && main.userProps["BOF"] == 0)
		main.components.leftPad.children[3].setEnabled(false, true);

	if (typeof main.userProps["TER"] != "undefined" && main.userProps["TER"] == 0)
		main.components.leftPad.children[4].setEnabled(false, true);

	if (typeof main.userProps["INV"] != "undefined" && main.userProps["INV"] == 0)
		main.components.leftPad.children[5].setEnabled(false, true);

	if (typeof main.userProps["DRW"] != "undefined" && main.userProps["DRW"] == 0) {
		main.cmpCashbox.components.menuContainer.components.functionButtons.
		children[0].setEnabled(false);
		main.cmpCashbox.components.menuContainer.components.functionButtons.
		children[1].setEnabled(false);
		main.cmpCashbox.components.menuContainer.components.functionButtons.
		children[2].setEnabled(false);
	}

	if (typeof main.userProps["CNG"] != "undefined" && main.userProps["CNG"] == 0) {
		main.cmpCashbox.components.menuContainer.components.functionButtons.
		children[3].setEnabled(false);
	}

	// NUMMERIERUNG: Der Funkscanner-Knopf sass auf Index 8 und ist entfallen
	// (26.8.2026) - die folgenden Tasten sind um eins aufgerueckt. Die Rechte
	// haengen ALLEIN am Index; die Pruefung auf das Recht "SCA" (Scanner) ist
	// mit dem Knopf weggefallen.
	if (typeof main.userProps["CMP"] != "undefined" && main.userProps["CMP"] == 0)
		main.components.leftPad.children[8].setEnabled(false, true);

	if (typeof main.userProps["TRP"] != "undefined" && main.userProps["TRP"] == 0)
		main.components.leftPad.children[9].setEnabled(false, true);

	if (!POS.isPOSOpened) {
		if (typeof main.userProps["POP"] != "undefined" && main.userProps["POP"] == 0)
			main.components.leftPad.children[10].setEnabled(false);
	} else {
		if (typeof main.userProps["POC"] != "undefined" && main.userProps["POC"] == 0)
			main.components.leftPad.children[10].setEnabled(false);
	}

	if (POS.EnvProperties.BANKOMATTERMINAL != "YES")
		main.components.leftPad.children[4].setEnabled(false, true);

	//BonEdit:

	if (typeof main.userProps["CHP"] != "undefined" && main.userProps["CHP"] == 0)
		main.components.bonedit.children[3].setEnabled(false, true);

	//BonFnc:

	if (main.userProps["MaxGlobalRebate"] == 0)
		main.components.bonfnc.children[4].setEnabled(false, true);

	if (main.userProps["MaxRebate"] == 0) {
		main.components.bonedit.children[4].setEnabled(false, true);
		main.components.bonedit.children[5].setEnabled(false, true);
	}

	//Submenu 'Other Functions':

	if (typeof main.userProps["SHD"] != "undefined" && main.userProps["SHD"] == 0) {
		main.cmpOtherFunc.components.menuContainer.components.functionButtons.
		children[2].setEnabled(false);
		//main.cmpOtherFunc.components.menuContainer.components.functionButtons.
		//    children[3].setEnabled(false);
	}

	if (POS.isPOSOpened)
		main.cmpOtherFunc.components.menuContainer.components.functionButtons.
		children[2].setEnabled(false);

	if (typeof main.userProps["COL"] != "undefined" && main.userProps["COL"] == 0) {
		// Obergrenze 11 statt 12: der Funkscanner-Knopf ist am 26.8.2026
		// entfallen, das Panel hat nur noch 12 Tasten (Index 0..11).
		for (var i = 1; i < 11; i++)
			main.components.leftPad.children[i].setEnabled(false, true);
		main.cmpOtherFunc.components.menuContainer.components.functionButtons.
		children[1].setEnabled(false, true);
	}

	//Always off:
	if (main.components.payment2.children[6 - main.components.payment.buttons.length])
		main.components.payment2.children[6 - main.components.payment.buttons.length].setEnabled(false, false);
	//main.cmpInventory.components.menuContainer.components.functionButtons.
	//    children[3].setEnabled(false, true);
	//main.cmpInventory.components.menuContainer.components.functionButtons.
	//    children[4].setEnabled(false, true);
}

export { CUserRights };
